import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faPeopleRoof } from "@fortawesome/free-solid-svg-icons";
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Python",
    "Pandas",
    "Numpy", 
    "Matplotlib",
    "Matlab",
    "TensorFlow",
    "Jupyter",
    "Tableau",
    "SAS"     
];

const labelsSecond = [
    "SAP",
    "ERP",
    "Power BI",
    "Tableu",
    "SQL",
    "Exel",
    "Lean Six Sigma"
];

const labelsThird = [
    "SAP MM",
    "SAP PP",
    "ERP Systems",
    "Process Mapping",
    "Inventory Management",
    "Demand Planning",
    "Forecasting"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h2 className="section-heading">Expertise</h2>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faDatabase} size="3x"/>
                    <h3>Data Science</h3>
                    <p>As an industrial engineer with a focus on Data Science, I combine analytical thinking with technical expertise to drive data-driven decisions and innovative solutions.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faChartLine} size="3x"/>
                    <h3>Business Analytics & Process Optimization</h3>
                    <p>By combining industrial engineering principles with data science, I focus on analyzing complex business processes and optimizing workflows to improve efficiency, reduce costs, and support data-driven decision making.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPeopleRoof} size="3x"/>
                    <h3>Supply Chain & Operations Management</h3>
                    <p>With hands-on experience in inventory planning, supply chain coordination, and process efficiency, I help organizations optimize resource utilization, improve productivity, and achieve sustainable operational excellence.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;